import { InputDate } from "@sellar-io/components";
import { getPaymentDue } from "@sellar-io/common";
import dayjs from "dayjs";
import { ReactElement, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { useSupplierRelationshipList } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";

export function OrderPaymentDueFormFragment({
  retailerId,
  form,
}: {
  retailerId: number;
  form: UseFormReturn<{ paymentDue: string | null }>;
}): ReactElement | null {
  const supplierRelationshipQuery = useSupplierRelationshipList({
    query: [
      {
        type: "buyerId",
        modifier: "EQUALS",
        value: retailerId,
      },
    ],
  });

  useEffect(() => {
    const connection = supplierRelationshipQuery.data?.pages[0]?.[0];
    if (connection?.paymentDue) {
      form.setValue(
        "paymentDue",
        dayjs(
          getPaymentDue({
            paymentDue: connection.paymentDue,
            paymentDueCalculateFrom:
              connection.paymentDueCalculateFrom ?? "invoiceIssueDate",
          }),
        ).format("YYYY-MM-DD"),
      );
    }
  }, [supplierRelationshipQuery.data, form]);

  return (
    <>
      {supplierRelationshipQuery.data?.pages[0]?.[0] && (
        <div>
          <InputLabel>Payment due date</InputLabel>
          <InputContainer>
            <InputDate
              className={"w-full"}
              {...form.register("paymentDue", {
                required: "Payment due must be provided",
              })}
              min={dayjs().add(1, "day").startOf("day").format("YYYY-MM-DD")}
            />
          </InputContainer>
        </div>
      )}
    </>
  );
}
